export const InputType = {
    WebLink: 'WebLink',
    Email: 'Email'
};